// extracted by mini-css-extract-plugin
module.exports = {"button":"button__2KsB-","large":"large__S8xhV","bordered":"bordered__1fgFn","warning":"warning__2vIz3"};